import React from 'react';
import { ButtonProps as MuiButtonProps } from '@mui/material';
import { StyledButton } from './Button.style';

export interface ButtonProps extends Omit<MuiButtonProps, 'size'> {
  /**
   * The size of the button
   */
  size?: 'small' | 'medium' | 'large';
  /**
   * Whether the button should take full width
   */
  fullWidth?: boolean;
  /**
   * Whether the button is in loading state
   */
  loading?: boolean;
}

export const Button: React.FC<ButtonProps> = ({
  children,
  size = 'medium',
  fullWidth = false,
  loading = false,
  disabled,
  ...props
}) => {
  return (
    <StyledButton
      size={size}
      fullWidth={fullWidth}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? 'Loading...' : children}
    </StyledButton>
  );
}; 